module.exports = __webpack_public_path__ + "static/media/eb-easybib-plus.c122b3a2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/eb-easybib-plus.svg
// module id = 5751
// module chunks = 11